import React from 'react';

import Base64Image from '../../../lib/components/Base64Image';
import { IUnpackedRelatedProduct } from '../../../models/MessagePreview/UnpackedRelatedProduct';
import NewsText from './NewsText';

interface IProps {
  relatedProduct: IUnpackedRelatedProduct;
}

const DiscoveryRelatedProduct = (props: IProps) => {
  const { relatedProduct } = props;
  const contentType =
    relatedProduct.content_type ?
      <div className="related-product-content-type">{relatedProduct.content_type}</div> :
      null;
  const isSwitch2 = relatedProduct.label_platform == 'ounce';
  return (
    <div className="discovery-related-product-card">
      <div className="discovery-related-product-image-area">
        {
          isSwitch2 && <div className="discovery-related-product-image-top-bar" >
            <div className="discovery-related-product-image-top-bar-icon"></div>
          </div>
        }
        <Base64Image className={isSwitch2 ? 'discovery-related-product-image-switch2' : 'discovery-related-product-image'} image={relatedProduct.image} />
      </div> 
      {contentType}
      <div className={isSwitch2 ? 'discovery-related-product-name  discovery-related-product-heigh-switch2' : 'discovery-related-product-name'}>
        <NewsText className="word-ellipsis" text={relatedProduct.name} />
      </div>
      <div className={isSwitch2 ? 'discovery-related-product-wish  discovery-related-product-heigh-switch2' : 'discovery-related-product-wish'}>
        <div className={isSwitch2 ? 'discovery-related-product-wish-icon  discovery-related-product-heigh-switch2' : 'discovery-related-product-wish-icon'}></div>
      </div>
    </div>
  );
};

export default DiscoveryRelatedProduct;
